module.exports = __webpack_public_path__ + "static/media/printing-stationery.460a42ba.svg";